// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Component: React.LazyExoticComponent<any> = React.lazy(() => import('../components/customers/List'));

export default class Customers extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        title: 'Management | Customers',
        active: true,
        component: Component,
        props: {
          report: 'MANAGEMENT_CUSTOMERS',
          title: 'Customers',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
